/* eslint-disable array-callback-return */
export const addFilter = (
  value,
  data,
  temporalFilters,
  readSectors = false,
) => {
  try {
    let temp;
    if (data && data.length !== 0) {
      if (Array.isArray(data)) {
        switch (value) {
          case 'condition':
            temp = [];
            data.map((item, i) => {
              createFilter(temp, 'status', '=', item.id, i === data.length - 1);
            });
            temporalFilters.push([temp]);
            break;
          case 'type':
            temp = [];
            data.map((item, i) => {
              createFilter(
                temp,
                'category',
                'contains',
                item.name,
                i === data.length - 1,
              );
            });
            temporalFilters.push([temp]);
            break;
          case 'sectors':
            if (readSectors) {
              temp = [];
              data.map((item, i) => {
                createFilter(
                  temp,
                  'nameSector',
                  '=',
                  item.name,
                  i === data.length - 1,
                );
              });
              temporalFilters.push([temp]);
              break;
            } else {
              break;
            }
          case 'collaborators':
            temp = [];
            data.map((item, i) => {
              createFilter(
                temp,
                'employee_Nr',
                '=',
                item.meta4EmployeeId,
                i === data.length - 1,
              );
            });
            temporalFilters.push([temp]);
            break;
          case 'conditionCollab':
            temp = [];
            data.map((item, i) => {
              createFilter(temp, 'active', '=', item.id, i === data.length - 1);
            });
            temporalFilters.push([temp]);
            break;
          case 'shifts':
            temp = [];
            data.map((item, i) => {
              createFilter(
                temp,
                'iD_Shift',
                '=',
                item.iD_Shift,
                i === data.length - 1,
              );
            });
            temporalFilters.push([temp]);
            break;
          default:
            temp = [];
            data.map((item, i) => {
              createFilter(temp, value, '=', item);
            });
            temporalFilters.push(temp);
            break;
        }
      } else {
        temp = [];
        createFilter(temp, value, '=', data);
        temporalFilters.push(temp);
      }
      temporalFilters[0] && temporalFilters.push('and');
    }
    return temporalFilters;
  } catch (error) {
    console.error(error);
  }
};

const createFilter = (
  temporalFilters,
  columnName,
  operation,
  value,
  last = false,
) => {
  if (columnName === 'status' && value === 0) {
    temporalFilters.push([columnName, operation, 0], 'or', [
      columnName,
      operation,
      2,
    ]);
  } else if (columnName === 'doc_Number') {
    temporalFilters.push([columnName, 'contains', value]);
  } else if (columnName === 'startDate') {
    temporalFilters.push(['Instance_Date', '>=', value]);
  } else if (columnName === 'endDate') {
    temporalFilters.push(['Instance_Date', '<=', value]);
  } else {
    temporalFilters.push([columnName, operation, value]);
  }
  !last && temporalFilters.push('or');
};
